import { CancelToken } from 'axios'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils/axios'

import { Wastestream } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<Wastestream.Basic>> =>
	Http.get(baseUrl, { params })

export const retrieveWasteStreamServiceSites = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/service-sites/available-for-customer`)

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<Wastestream.Search.Result> =>
	Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const searchByRefCode = async (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<string[]> => {
	const response: Wastestream.Search.RefCodeResponse = await Http.get(
		`${baseUrl}/search-suggestions/refcode`,
		{ params, cancelToken }
	)
	return response.refCodes
}

export const searchBySupplierLocation = async (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<string[]> => {
	const response: Wastestream.Search.SupplierLocationResponse = 
		await Http.get(
		`${baseUrl}/search-suggestions/supplier-location`, { params, cancelToken }
	)
	return response.supplierLocations
}

export const retrieveWastestream = (id: Key): Promise<Wastestream.Detailed> =>
	Http.get(`${baseUrl}/${id}`)

export const downloadProfileFile = (wastestreamId: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/${wastestreamId}/profile/download`, {
		responseType: 'blob'
	})
